// extracted by mini-css-extract-plugin
export default {"wrappers":"portfolio_wrappers__KOvwe","an":"portfolio_an__KuevZ"};